import { Component, Input, OnInit, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-paginacion-v2',
  templateUrl: './paginacion-v2.component.html',
  styleUrls: ['./paginacion-v2.component.scss']
})
export class PaginacionV2Component implements OnInit, OnChanges {

  @Input() lngRegistros = 0;
  @Input() registrosXpagina = 10;
  paginaActual = 1;
  totalPaginas = 0;
  registroDesde = 0;
  registroHasta = 0;
  
  @Output() eventos = new EventEmitter<{ registroDesde: number, registroHasta: number }>();
  // infoPag = { registroDesde: 0, registroHasta: 0 };

  constructor() { }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.configurar();
  }

  configurar() {
    if (!this.lngRegistros || !this.registrosXpagina) return null;
    const div = this.lngRegistros / this.registrosXpagina;
    this.totalPaginas = Math.ceil(div);
    this.registroDesde = 1;
    const finReg = this.registrosXpagina;
    this.registroHasta = finReg > this.lngRegistros ? this.lngRegistros : finReg;
    this.paginaActual = 1;
    this.eventos.emit({ registroDesde: this.registroDesde, registroHasta:this.registroHasta })
  }

  siguientePagina() {
    if (this.paginaActual >= this.totalPaginas) return;
    this.paginaActual =+1;
    this.registroDesde = ((this.paginaActual - 1) * this.registrosXpagina) + 1;
    this.registroHasta = this.paginaActual * this.registrosXpagina; 
  }

  ejecutarAccion(accion: string) {
    if (!accion) return;
    const acc = {
      primera: () => {
        if (this.paginaActual === 1) return;
        this.paginaActual = 1;
        acc.reConfigurar();
      },
      anterior: () => {
        if (this.paginaActual === 1) return;
        this.paginaActual =this.paginaActual - 1;
        acc.reConfigurar();
      },
      siguiente: () => {
        if (this.paginaActual >= this.totalPaginas) return;
        this.paginaActual = this.paginaActual + 1;
        acc.reConfigurar();
      },
      reConfigurar: () => {
        this.registroDesde = ((this.paginaActual - 1) * this.registrosXpagina) + 1;
        this.registroHasta = this.paginaActual * this.registrosXpagina;
        console.log(this.paginaActual, this.registroDesde, this.registroHasta);
        
        this.eventos.emit({ registroDesde: this.registroDesde, registroHasta:this.registroHasta })
      },
      ultima: () => {
        if (this.paginaActual >= this.totalPaginas) return;
        this.paginaActual = this.totalPaginas;
        acc.reConfigurar();
      }
    };
    if (!Object.keys(acc).includes(accion)) return console.log('No existe la acción::', accion);
    acc[accion]();
  }
  
}
